import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;

  > div {
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
`;

type Props = {
  width?: number;
  children: React.ReactNode;
};

const MaxContentWrapper = ({ width = 1440, children }: Props) => {
  return (
    <Wrapper>
      <div style={{ maxWidth: `${width}px` }}>{children}</div>
    </Wrapper>
  );
};

export default MaxContentWrapper;
